import React from 'react';
import ShareButton from './components/resultList/shareButton/shareButton';
import HeaderResult from './components/headerResult/headerResult';
import ResultList from './components/resultList/resultList';
import FooterResult from './components/footerResult/footerResult';
import './styles/vacationFinderResultBase.scss';

const VacationFinderResultBase = () => {
  return (
    <>
      <ShareButton />
      <HeaderResult />
      
      <ResultList />

      <FooterResult />
    </>
  )
}

export default VacationFinderResultBase
